import { render, staticRenderFns } from "./headers-tab.vue?vue&type=template&id=49640262"
import script from "./headers-tab.vue?vue&type=script&lang=js"
export * from "./headers-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports